import { render, staticRenderFns } from "./ShieldIntro.vue?vue&type=template&id=2230519a&scoped=true&"
import script from "./ShieldIntro.vue?vue&type=script&lang=js&"
export * from "./ShieldIntro.vue?vue&type=script&lang=js&"
import style0 from "./ShieldIntro.vue?vue&type=style&index=0&id=2230519a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2230519a",
  null
  
)

export default component.exports